<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
          <div class="titleDiv">
                
                    <h2><strong>Accident List</strong></h2>
                    <hr>
                    <h4>View your accident records here.</h4>
<br>                    
        
       
            </div>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Expandable Table-->
                <div class="box">
                    <div class="box-header with-border">
                        <h3 class="box-title">Accident List</h3>
                        <div class="box-tools pull-right">
                            <button type="button" data-widget="collapse" data-toggle="tooltip" title="Collapse" class="btn btn-box-tool"><i class="ti-minus"></i></button>
                        </div>
                    </div>
                    <div  class="box-body">
                        <el-table
                        id="accidentTable"
                        empty-text="There is no accident data to display."
                        :data="accidentList"
                        style="width: 100%;">
                        <el-table-column type="expand" >
                          <template scope="props">
                            <div>
                              <h3><strong>Accident Details</strong></h3>
                              <hr>
                            <p><strong>Accident Name:</strong> {{ props.row.accidentName }}</p>
                            <p><strong>Date of Accident:</strong> {{ props.row.accidentDate }}</p>
                            <p><strong>Accident Type:</strong> {{ props.row.accidentType }}</p>
                            <p><strong>Accident Location:</strong> {{ props.row.accidentLocation }}</p>
                            <p><strong>Additional Accident Information:</strong> {{ props.row.additionalAccidentInformation }}</p>
                            </div>
                            <br>
                             <div>
                               <h3><strong>Vehicle Details</strong></h3>
                               <hr>
                            <p><strong>Vehicle Year:</strong> {{ props.row.vehicleYear }}</p>
                            <p><strong>Vehicle Make:</strong> {{ props.row.vehicleMake }}</p>
                            <p><strong>Vehicle Model:</strong> {{ props.row.vehicleModel }}</p>
                            <p><strong>Vehicle Speed:</strong> {{ props.row.vehicleSpeed }} MPH</p>
                            </div>
                            <br>
                             <div>
                               <h3><strong>Other Details Noted</strong></h3>
                               <hr>
                            <strong>Accident Services Requested:</strong> 
                            <hr>
                            <p v-for="service in props.row.accidentServicesRequested"><span style="vertical-align: top;">{{service.stringValue}}</span> </p>
                            <hr>
                            </div>
                                                     <button class="btn btn-primary" v-on:click="viewAccident(props.row.accidentId)"> <span class="fa fa-eye"></span>&nbsp;&nbsp;View Full Accident Details</button>

                          </template>
                        </el-table-column>
                       
               

                         
                         <el-table-column
                          label="Date of Accident"
                          >
                          <template scope="props">
                          <span class="bold"><strong>{{props.row.accidentDate}}</strong></span>
                          </template>
                        </el-table-column>
                                                <el-table-column
                          label="Location"
                          >
                         <template slot-scope="scope">
    <span>{{scope.row.accidentLocation}}</span>
                </template>
                        </el-table-column>
                         <el-table-column
                          label="Options"
                          >
                          <template scope="props">
                         <button class="btn btn-success" v-on:click="editAccident(props.row.accidentId)"> <span class="fa fa-edit"></span>&nbsp;&nbsp;Edit Accident</button>
                        <button class="btn btn btn-danger" v-on:click="deleteAccident(props.row.accidentId)"><span class="fa fa-minus-circle"></span>&nbsp;&nbsp;Delete Accident</button>
                          </template>
                        </el-table-column>
                      </el-table>
                      <br>
      
                      <router-link to="/accidentInformationPage">
                          <el-button style="margin-left:40%;" size="small" type="primary"><span class="fa fa-plus-circle"></span>&nbsp;&nbsp;Add New Accident</el-button>
                      </router-link>
                    </div>
                </div>
                <!-- End of Expandable Table-->
          
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
        const cliStorage = require('../../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
const Auth = require('../../services/Authentication/auth')
const db = require('../../services/database/database')
  const commonDB = require('../../services/database/common')
const _ = require('lodash')
const cliStoreOps = require('../../common/clientStorageOperations')
const models = require('../../services/database/models')

        var to = require('await-to-js').default
    export default {
      name: 'AccidentList',
      async created(){
        const userToken = this.$cookie.get(cliStorNames.USER_TOKEN.name)
        if (!userToken){
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()

            this.$router.push('/login')
        }
        this.userToken = userToken
        const jwt_decode = require('jwt-decode');

         const decoded_header = jwt_decode(userToken)
          this.userAccountId = decoded_header.user_id
        let userErr, userRes;
          [userErr, userRes] = await to(Auth.getUser({ UID: userToken }));
          if (userErr) {
            console.log("getting user userErr", userErr.response);
            cliStoreOps.deleteAllCookies()
                        cliStoreOps.deleteAllLocalStorageItems()

            this.$router.push('/login')
          } else if (userRes) {
              console.log("userRes",userRes)
              const userId = this.$cookie.get(cliStorNames.USER_ID.name)
              if (!userId)
              {
                //TODO: eventually need to add plan B here, maybe just look up the user and get the ID
                console.warn("No user id found.")
              }
              this.userId = userId
let userDbRes, userDbErr; 
                  [userDbErr, userDbRes]= await to(commonDB.getUserFromDB(this.userToken, this.userAccountId))
                  if (userDbErr){
                      console.error(userDbErr)
                      this.$confirm("Unable to Load Profile Contents. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                 console.log("userDBRES", userDbRes)
                                    let pulledUserId = userDbRes.data.fields.userId.stringValue
                                    //VERY IMPORTANT! ==> Keeps 1 user from accesing another user's profile
                if (pulledUserId !== this.userId){
                     this.$confirm("Unable to retrieve User Profile. Please try again at a later time.", 'User Profile Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
}
               let dbRes, dbErr; 
                  [dbErr, dbRes]= await to(commonDB.getAccidentsFromDB(this.userToken, this.userAccountId))
                  if (dbErr){
                      console.error(userDbErr)
                       this.$confirm("Unable to load Accidents. Please try again at a later time.", 'Loading Accident Items Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
                  console.log("Pulled accidents!", dbRes)
                  try{
                    if(!_.isEmpty(dbRes) && !_.isEmpty(dbRes.data)){
                  for (var entry of  dbRes.data.documents){
                    if(!entry){ //to prevent crashing
                      break;
                    }
                                      let accident = {};
                    console.log(entry)
                    console.log("here now")
                                          accident.accidentName = entry.fields.accidentName.stringValue
                                          console.log(accident.accidentName)

                      accident.accidentType = this.convertAccidentType(entry.fields.accidentType.stringValue)
                                          console.log(accident.accidentType)

              accident.accidentTime = entry.fields.accidentTime.stringValue
                                                        console.log(accident.accidentTime)

              let accidentDate = entry.fields.accidentDate.stringValue 
              accident.accidentDate = accidentDate
              if(accidentDate !== ''){
              accident.accidentDate = new Date(accidentDate).toString()
              if(accident.accidentTime){
                console.log(accident.accidentTime)
               accident.accidentDate = accident.accidentDate.replace(/\d\d:\d\d:\d\d[\s\S]*$/, accident.accidentTime)
                console.log(accident.accidentDate)
              }
              }
                                                        console.log(accident.accidentDate)

              accident.vehicleMake = entry.fields.vehicleMake.stringValue
                                                        console.log(accident.vehicleMake)

              accident.vehicleModel = entry.fields.vehicleModel.stringValue
              accident.vehicleYear = entry.fields.vehicleYear.stringValue
              accident.vehicleSpeed = entry.fields.vehicleSpeed.stringValue
                                                                      console.log(accident.vehicleSpeed)

              accident.accidentId = entry.fields.accidentId.stringValue,
              accident.accidentLocation = entry.fields.accidentLocation.stringValue
              accident.accidentClaimStatus = entry.fields.accidentClaimStatus.stringValue
              accident.additionalAccidentInformation = entry.fields.additionalAccidentInformation.stringValue
              console.log(new Date(parseInt(entry.fields.timeSubmitted.stringValue)))
              accident.timeSubmitted = new Date(parseInt(entry.fields.timeSubmitted.stringValue)).toString(),
              accident.accidentServicesRequested = entry.fields.accidentServicesRequested.arrayValue.values
              console.log("services",  accident.accidentServicesRequested)
              this.accidentList.push(accident)
        
                  }
                    }
                  }
                  catch(err){
                    console.error(err)
                     this.$confirm("Unable to retrieve Accident Entries. Please try again at a later time.", 'Accident List Error', {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'}).then(this.$router.push('/'))
                  }
              
          

                  

      }
      
      },
      data: function () {
        return {
          userId: '',
          accidentList: [],
          userToken: "",
          accidentTypeMap: {
         'rearEnd' :'Rear-End',
         'headOn': 'Head-On',
          'fenderBender': 'Fender-Bender',
          'sideImpactCollision':'Side-impact collision',
           'singleCar': 'Single Car Accident(No other driver involved)'
        },
         
        }
      },
      methods:

      {
             updateDiv: function(id)
{ 
    $( id ).load(window.location.href + id );
},
        viewAccident: function(accidentId){
        console.log(accidentId)
          this.$cookie.set(cliStorNames.ACCIDENT_ID.name, accidentId)
        this.$router.push({name: 'ViewAccident', params: {accidentId }})
        },
        
        editAccident: function(accidentId){
          console.log(accidentId)
          this.$cookie.set(cliStorNames.ACCIDENT_ID.name, accidentId)
        this.$router.push({name: 'EditAccident', params: {accidentId }})

        },

         deleteAccident: async function(accidentId){
        let userNo, userYes;
        [userNo, userYes] = await to(this.$confirm("Are you sure you want to delete this accident entry?" ,  'WARNING', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'}))

        if (userNo){
            console.log("no")
        }
    //     if(userYes){
    //         let confirmNo, confirmYes;
    //         [confirmNo, confirmYes] = await to(this.$confirm("Are you absolutely sure you want to delete your profile?",  'WARNING', {
    //              auth: true,
    //     confirmButtonText: 'Yes',
    //     cancelButtonText: 'No'})
    // )

        if(userYes){
         //get user from DB
         const jwt_decode = require('jwt-decode');

         const decoded_header = jwt_decode(this.userToken)
          const userAccountId = decoded_header.user_id
       

                     const documentPath = "users/" + userAccountId + "/accidents/" + accidentId;


         let delErr, delRes;

         [delErr, delRes] = await to(db.deleteDocument(this.userToken, documentPath))

         if (delErr){
           console.error(delErr)
           throw delErr
         }
         this.accidentList = this.accidentList.filter(e => e.accidentId !== accidentId)
//this.updateDiv("#accidentTable")
// this.updateDiv('#scrollDiv')
// this.updateDiv('.slimcrollDiv')
// this.updateDiv("#main-sidebar")
//var w=230;
    
         //location.reload();

        
        }
        
    },

      

             
    

      
      convertAccidentType: function(unformattedAccidentType){
        return this.accidentTypeMap [unformattedAccidentType]
      }
      }
    }
</script>
<style scoped>

@media(min-width: 500px) {
.titleDiv {
  background:white;
  
}
}
@media(max-width: 500px){
  .titleDiv {
  background:white;
  margin-top: 10%;
  
}
}
</style>


// WEBPACK FOOTER //
// AccidentList.vue?104239c4